<template>
    <div>
        <h3>成员信息</h3>
        <!-- <el-form :inline="true" class="demo-form-inline" size="mini">
            <el-form-item label="创建者手机号">
                <el-input placeholder="输入手机号" v-model="filter.phoneNumber"></el-input>
            </el-form-item>
            <el-form-item label="企业名称">
                <el-input placeholder="输入企业名称" v-model="filter.enterprise"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" @click="fetch(1)">查询</el-button>
            </el-form-item>
        </el-form> -->
        <el-table :data="list" size="mini" v-loading="loading">
            <el-table-column prop="userId" label="用户id"></el-table-column>
            <el-table-column prop="nickname" label="昵称"></el-table-column>
            <el-table-column prop="enterprise" label="企业名称"></el-table-column>
            <el-table-column prop="entId" label="企业id"></el-table-column>
            <el-table-column prop="avatar" label="头像">
                <template slot-scope="scope">
                    <img style="height: 40px;width: 40px;" :src="scope.row.avatar" alt="" srcset="">
                </template>
            </el-table-column>
            <el-table-column prop="phoneNumber" label="手机号"></el-table-column>
            <el-table-column prop="email" label="邮箱"></el-table-column>
        </el-table>
        <br />
        <div>
            <el-pagination background layout="prev, pager, next" :current-page="pageNum"
                @current-change="i => pageNum = i" :page-size="limit" :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import map from '../../datamap'

import api from '../api'
let {
    ent,

} = api
export default {
    name: 'entList',
    data() {
        return {
            map,
            filter: {
                phoneNumber: '',
                enterprise: '',
            },
            loading: true,
            list: [],
            total: 0,
            pageNum: 1,
            limit: 20,
            industries: [],
        }
    },
    computed: {
        uid() {
            return this.$route.query.publisherId;
        }
    },
    watch: {
        pageNum() {
            this.fetch()
        }
    },
    created() {
    },
    methods: {
        async fetch(num) {
            if (num == 1) {
                this.pageNum = 1;
            }

            let {
                phoneNumber,
                enterprise,
            } = this.filter;

            this.loading = true;
            let {
                data: {
                    data,
                    code,
                    desc,
                    pageinfo,
                }
            } = await ent.member({
                pageNum: this.pageNum,
                limit: this.limit,
                userId: this.uid,
                phoneNumber,
                enterprise,
            })
            if (code == 200) {
                this.list = data;
                this.total = pageinfo.totalCount;
            }
            this.loading = false;
        },

    },
    mounted() {
        this.fetch()
    }
}
</script>
<style></style>


// WEBPACK FOOTER //
// src/views/ent/member.vue